import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    kpiId = '',
    id = '',
    parentId = '',
    name = '',
    compareMode = 0,
    value = 0,
    nValue = '',
    unit,
    explain,
    summary,
    code,
    std,
    basis,
    scoreStd,
    order = 0,
    classify = 0, // 指标分类, 1: 产出指标, 2: 效益指标, 3: 满意度指标
    scoreWeight = 1.0, // 得分权重, 1.0: 平均得分, < 1.0: 占比得分, > 1.0: 加权平均得分
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpiItem.save, {
        kpiId,
        id,
        parentId,
        name,
        compareMode,
        value,
        nValue,
        unit,
        explain,
        summary,
        code,
        std,
        basis,
        scoreStd,
        order,
        classify,
        scoreWeight,
    }, options);
    if (error) return { error, status };
    return content || {};
};

